import React, { useMemo } from 'react';
import ReactPlayer from 'react-player';

type Props = {
  url: string;
};

const ResponsivePlayer: React.FC<Props> = ({ url }) => {
  const userAgent = navigator.userAgent;
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const isIOSApp = useMemo(() => {
    if (!isIOS) return false;
    if (window.location.href.includes('capacitor://')) return true;
    if ((window.navigator as any).standalone) return true;
    if (userAgent.includes('Mobile/') && !userAgent.includes('Safari/')) return true;
    return false;
  }, [isIOS, userAgent]);

  const shouldForceHLS = useMemo(() => {
    if (!url?.includes('.m3u8')) return false;
    return !isSafari;
  }, [url, isSafari]);

  if (!url) return null;

  // For HLS streams on iOS apps, use native video
  if (url.includes('.m3u8') && isIOSApp) {
    return (
      <div className="player-wrapper rounded-lg overflow-hidden">
        <video
          width="100%"
          height="100%"
          controls
          playsInline
          preload="metadata"
          controlsList="nodownload"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        >
          <source src={url} type="application/x-mpegURL" />
          Your browser does not support the video tag.
        </video>
      </div>
    );
  }

  return (
    <div className="player-wrapper rounded-lg overflow-hidden">
      <ReactPlayer
        className="react-player"
        url={url}
        width="100%"
        height="100%"
        controls
        pip={!isIOSApp}
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload',
              playsInline: true,
            },
            forceVideo: true,
            forceHLS: shouldForceHLS,
          },
        }}
        playing={false}
        playsinline
      />
    </div>
  );
};

export default ResponsivePlayer;
